import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

import Icon from '../../Icon';
import {useHandlerOnOuterClick} from '../../../Utils/Hooks';
import {TSelectboxProps, TOption} from '../definitions';

export const Selectbox = ({options, onUpdate, value, label, isInvalid, className}: TSelectboxProps) => {
	const currentOptionIndex = options.findIndex(option => option.value === value);
	const currentOption = options[currentOptionIndex];

	const [isOpen, updateIsOpen] = React.useState(false);
	const node: React.RefObject<HTMLDivElement> = useHandlerOnOuterClick(() => updateIsOpen(false));
	const input: React.RefObject<HTMLInputElement> = React.useRef(null);

	const toggle = () => updateIsOpen(state => !state);
	const update = (value: string|number) => {
		onUpdate(value);
		toggle();
	};

	const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
		switch (e.key) {
			case 'Enter':
			case ' ':
				toggle();
				break;
			case 'Escape':
				updateIsOpen(false);
				break;
			case 'ArrowDown': {
				const nextOption = currentOptionIndex >= 0
					? options[(currentOptionIndex + 1) % options.length]
					: options[0];

				onUpdate(nextOption.value);
				break;
			}
			case 'ArrowUp': {
				const nextOption = currentOptionIndex >= 0
					? options[(options.length + currentOptionIndex - 1) % options.length]
					: options[options.length - 1];

				onUpdate(nextOption.value);
				break;
			}
			default:
				return;
		}

		e.preventDefault();
		e.stopPropagation();
	};

	const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
		input.current?.focus();
	};

	return (
		<div
			ref={node}
			onClick={onClick}
			data-is-invalid={isInvalid ? "1" : "0"}
			className={classNames(
				styles.selectbox,
				isInvalid && styles.isInvalid,
				className
			)}
		>
			<input
				ref={input}
				type="checkbox"
				onKeyDown={onKeyPress}
			/>
			{
				label !== undefined &&
					<label>{label}</label>
			}
			<div
				onClick={toggle}
				className={styles.header}
			>
				<div className={styles.headerLabel}>
					<span>{currentOption?.label || currentOption?.value || ''}</span>
				</div>
				<Icon name="ChevronDown" spin={isOpen}/>
			</div>
			{
				isOpen && (
					<div className={styles.options}>
						{
							options.map((option: TOption) => (
								<div
									key={option.value}
									onClick={() => update(option.value)}
									className={classNames(
										styles.option,
										currentOption === option && styles.isHighlighted,
									)}
								>
									{option.label || option.value}
								</div>
							))
						}
					</div>
				)

			}
		</div>
	);
}
